import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaskModalService {
  private _isOpen = signal(false);
  private _taskId = signal<string | null>(null);

  readonly isOpen = this._isOpen.asReadonly();
  readonly taskId = this._taskId.asReadonly();

  openTask(taskId: string): void {
    this._taskId.set(taskId);
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
    this._taskId.set(null);
  }
}